import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { LOGO_WORDMARK, LOGO_CRESCENT } from "./data";
import { SocialLinks } from "./SocialLinks";

const HASHTAGS = [
  "#DeenDistrict",
  "#TheOrigin",
  "#Drop001",
  "#DeenOverDunya",
  "#MuslimStreetwear",
];

export const Footer = () => {
  return (
    <footer
      data-testid="footer-section"
      className="relative bg-[#ffffff] border-t border-[#e3e2dc] pt-20 pb-10 overflow-hidden"
    >
      <h2
        aria-hidden
        className="pointer-events-none select-none absolute -bottom-6 sm:-bottom-10 left-1/2 -translate-x-1/2 font-display font-extrabold uppercase text-[22vw] leading-none text-[#0a0a0b]/[0.04] whitespace-nowrap"
      >
        Deen District
      </h2>

      <div className="relative z-10 max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="flex flex-col items-center text-center gap-8">
          <img
            src={LOGO_WORDMARK}
            alt="Deen District"
            className="h-24 sm:h-28 object-contain"
          />
          <p className="font-serif-accent text-xl sm:text-2xl text-[#0a0a0b] max-w-md">
            “Before the Movement, There was Faith.”
          </p>

          <div className="flex flex-wrap items-center justify-center gap-2.5">
            {HASHTAGS.map((h) => (
              <span
                key={h}
                data-testid={`hashtag-${h.slice(1).toLowerCase()}`}
                className="font-mono-d text-[11px] uppercase tracking-[0.15em] text-[#5f5e5a] border border-[#e3e2dc] rounded-full px-4 py-2 hover:text-[#ff2a85] hover:border-[#ff2a85]/40 transition-colors cursor-default"
              >
                {h}
              </span>
            ))}
          </div>

          <SocialLinks prefix="footer" className="justify-center" />
        </div>

        <div className="mt-16 pt-8 border-t border-[#e3e2dc] flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <img
              src={LOGO_CRESCENT}
              alt=""
              className="h-7 w-7 object-contain"
            />
            <span className="font-mono-d text-[11px] uppercase tracking-[0.2em] text-[#5f5e5a]">
              Deen over Dunya
            </span>
          </div>
          <p className="font-mono-d text-[10px] uppercase tracking-[0.2em] text-[#5f5e5a]">
            © {new Date().getFullYear()} Deen District — The Origin · Drop 001
          </p>
          <div className="flex items-center gap-5">
            <Link
              to="/about"
              data-testid="footer-about-link"
              className="font-mono-d text-[10px] uppercase tracking-[0.2em] text-[#5f5e5a] hover:text-[#ff2a85] transition-colors"
            >
              About us
            </Link>
            <Link
              to="/contact"
              data-testid="footer-contact-link"
              className="font-mono-d text-[10px] uppercase tracking-[0.2em] text-[#5f5e5a] hover:text-[#ff2a85] transition-colors"
            >
              Contact
            </Link>
            <Link
              to="/wholesale"
              data-testid="footer-wholesale-link"
              className="font-mono-d text-[10px] uppercase tracking-[0.2em] text-[#5f5e5a] hover:text-[#ff2a85] transition-colors"
            >
              Sell Deen District
            </Link>
            <Link
              to="/track-order"
              data-testid="footer-track-link"
              className="font-mono-d text-[10px] uppercase tracking-[0.2em] text-[#5f5e5a] hover:text-[#ff2a85] transition-colors"
            >
              Track order
            </Link>
            <Link
              to="/ambassadors"
              data-testid="footer-ambassadors-link"
              className="font-mono-d text-[10px] uppercase tracking-[0.2em] text-[#5f5e5a] hover:text-[#ff2a85] transition-colors"
            >
              Ambassador Crew
            </Link>
            <Link
              to="/admin"
              data-testid="footer-admin-link"
              className="inline-flex items-center gap-1.5 font-mono-d text-[10px] uppercase tracking-[0.2em] text-[#5f5e5a] hover:text-[#ff2a85] transition-colors"
            >
              <Lock size={11} /> Admin access
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
